import {Printer} from "../../entities/Printer";
import {AdminPagingModel} from "./AdminPagingModel";
import {PrinterService} from "../../services/PrinterService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class PrinterAdminPagingModel extends AdminPagingModel<Printer>{
    static $inject = ['$q','PrinterService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:PrinterService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService, gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "printer";
    }
    displayName():string{
        return "Printers";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs = [['name','Name', null]];
        return this.$q.when();
    }
}
